export const SPHERE = "sphere";
export const BOX = "box";
export const RECT = "rect";
export const CIRCLE = "circle";

export const is3DType = (type) => {
    return type !== "circle" && type !== "rect";
};

export const getCorner = (_args) => {
    let [type, ... args] = _args;
    if (is3DType(type)) {
        return args[6];
    } else {
        let corner = args[4];
        return corner;
    }
}

export const getRepeats = (_args) => {
    let [type, ... args] = _args;
    if (is3DType(type)) {
        let repeats = args[8] || 0;
        return repeats;
    } else {
        let repeats = args[6];
        return repeats || 0;
    }
}

export const getRotation = (_args) => {
    let [type, ... args] = _args;
    if (is3DType(type)) {
        let rot = args[7] || 0;
        return rot;
    } else {
        let corner = args[5];
        return corner || 0;
    }
}

export const getPositions = (_args) => {
    let [type, ... args] = _args;
    if (is3DType(type)) {
        return [args[0], args[1], args[2]];
    } else {
        return [args[0], args[1]];
    }
};

export const getDimensions = (_args) => {
    let [type, ... args] = _args;
    if (is3DType(type)) {
        return [args[3], args[4], args[5]];
    } else {
        return [args[2], args[3]];
    }
};
